import "ci5/smart_form";

(function ($) {
  $.widget("comparethemarket.smart_form", $.chopin.smart_form, {
    options: {
      showHelpAutoOnBreakpoint: "large-desktop",
      showHelpOnHover: true,
      showHelpOnFocus: true,
      resetLabelsOnBreakpoint: false,
      helpTriggerHtml:
        '<span class="help-trigger info-box-toggle" title="Help"></span>',
      closedHelpTriggerText: "",
      openHelpTriggerText: "",
    },

    _create() {
      this._super();

      this._on({
        infoboxsetshown: this.helpPopoverShown,
        infoboxsethidden: this.helpPopoverHidden,
      });

      this.repositionIsolatedTriggers(this.element);
      window.addEventListener(
        "resize",
        this.repositionIsolatedTriggers.bind(this, this.element),
      );
    },
    repositionIsolatedTriggers($form) {
      const $triggers = $form.find(".info-box .help-trigger");

      $triggers.each((index, elem) => {
        const $trigger = $(elem);
        const triggerLeftPosition =
          $trigger.offset().left - $trigger.parent().offset().left;
        const triggerCssLeft = parseInt($trigger.css("left"), 10);

        if (triggerLeftPosition <= triggerCssLeft && $trigger.is(":visible")) {
          $trigger.addClass("help-trigger-no-spacing");
        } else {
          $trigger.removeClass("help-trigger-no-spacing");
        }
      });
    },

    helpPopoverShown() {
      const $control = this.element.find(".info-box-active");
      const $trigger = $control.find(".help-trigger");

      this.popoverResizeId = window.addEventListener(
        "resize",
        this.repositionHelpPopover.bind(this, $trigger),
      );
      this.repositionHelpPopover($trigger);
    },

    helpPopoverHidden() {
      window.removeEventListener("resize", this.popoverResizeId);
    },

    // Reposition the arrow on the help popover so it points to the help trigger
    repositionHelpPopover($trigger) {
      if (!this.getHelpPopoverElement($trigger).length) return;

      const left = this.getHelpPopoverTriggerHorizontalCenter($trigger);

      this.getHelpPopoverStylesheet().innerText = `
        @media (max-width: 1199px) {
          .help-content::before {
            left: ${left}px;
          }
        }
      `;
    },

    // Find the horizontal offset of the center of the help trigger from its parent
    getHelpPopoverTriggerHorizontalCenter($trigger) {
      return (
        $trigger.offset().left -
        this.getHelpPopoverElement($trigger).offset().left
      );
    },

    getHelpPopoverElement($trigger) {
      return $trigger.closest(".control-block").find(".help-content");
    },

    // Gets or creates a stylesheet for the help popover specific stylesheet.
    // Ordinarily this could just be applied to the element itself, but pseudoelements
    // like ::before and ::after are not part of the DOM and can't be directly styled.
    getHelpPopoverStylesheet() {
      let stylesheet = document.querySelector("#help-popover-style");
      if (!stylesheet) {
        stylesheet = document.createElement("style");
        stylesheet.setAttribute("id", "help-popover-style");
        document.querySelector("head").appendChild(stylesheet);
      }
      return stylesheet;
    },

    // Gets the bounding rect of an element relative to another element
    relativeBoundingRect(from, to) {
      const fromRect = from.getBoundingClientRect();
      const toRect = to.getBoundingClientRect();

      return {
        x: fromRect.x - toRect.x,
        y: fromRect.y - toRect.y,
        width: fromRect.width,
        height: fromRect.height,
      };
    },
  });
})(window.jQuery);
